export const settingsPage = {
  title: 'Account',
  emailAndPassword: {
    title: 'Email & Password',
    changePasswordButton: 'Change Password',
    emailChangeInfo: {
      informationText: 'Email can only be changed via',
      linkText: 'Customer Happiness'
    }
  },
  userInfo: {
    editButton: 'Edit',
    title: 'Full Name'
  },
  modal: {
    changePassword: {
      cancelButton: 'Cancel',
      confirmPasswordLabel: 'Confirm Password',
      header: 'Change Password',
      infoBanner: 'If you change your password, you will be automatically logged out',
      newPasswordLabel: 'New Password',
      saveButton: 'Save',
      title: 'Change Password',
      success: 'Password has been changed',
      reloginError: 'Something went wrong, you will be automatically logged out'
    },
    editFullName: {
      cancelButton: 'Cancel',
      firstName: 'First Name',
      header: 'Edit Full Name',
      lastName: 'Last Name',
      saveButton: 'Save',
      title: 'Full Name'
    }
  },
  constants: {
    FULL_NAME_SUCCESS: 'Full name changed successfully',
    PASSWORD_MATCH_MESSAGE: 'The passwords you enter do not match',
    SETTINGS_ERROR: 'Something went wrong. Please try again',
    nameError: 'Must contain at least 1 character',
    latinNameError: 'Must contain only latin characters',
    spacesNameError: 'Only spaces are not allowed',
    minLength: 'Must contain at least 8 characters',
    uppercase: '1 uppercase letter',
    lowercase: '1 lowercase letter',
    number: '1 number',
    spacesPasswordError: 'Space symbol is not allowed',
    passwordCaption: 'Must contain at least 8 characters'
  }
};
